module.exports = __webpack_public_path__ + "img/head2.00f87eb5.png";